import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import BulkAssociationSearchForm from './BulkAssociationSearchForm';
import SearchView from "../../../widgets/SearchView";
import withMenuPermission from "../../../widgets/withMenuPermission";
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "../../../ViewUtils";
import AlertItem from "../../../widgets/AlertItem";
import { DiAssociationDetailForm } from "./DiAssociationDetailForm";
import FormDialog from "../../FormDialog";

const utils = new ViewUtils();
const toolbarRef = React.createRef();
const addFormRef = React.createRef();

const roleSRU = "SRU Administrator";

const headCells = [
    { id: 'LearnerFirstName', numeric: false, disablePadding: false, label: 'First Name' },
    { id: 'LearnerLastName', numeric: false, disablePadding: false, label: 'Last Name' },
    { id: 'LearnerIDNumber', numeric: false, disablePadding: false, label: 'ID Number' },
    { id: 'AssociationDetailCode', numeric: false, disablePadding: false, label: 'Programme Code' },
    { id: 'AssociationDetailDescription', numeric: false, disablePadding: false, label: 'Programme Description' },
    { id: 'OrganisationSDLNumber', numeric: false, disablePadding: false, label: 'Vendor Number' }
];


class BulkGrantDeAssociation extends Component {

    constructor(props) { 
        super(props) 
        this.state = { 
            model: { 
                FinancialYearID: null, 
                DiscretionaryGrantTypeID: null, 
                EmployerID: null, 
                SocioEconomicStatusID: null,
                BursaryInstitutionID: null,
                WAID: null,
            }, 
            IDs: null, 
            keyUpSwitch: false,
            LearnerCount: 0,
            clearGrid: false,
            formDialogOpen: false,
            GrantsLinked: false,
            messsageAlert: null,
            messageStyle: null,
            searchParameters: [{ Name: "DiscretionaryGrantTypeID", Value: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.DiscretionaryGrantTypeID)) ? this.props.location.state.DiscretionaryGrantTypeID : null }],
            DiscretionaryGrantTypeID: null,
            showTable: true
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        {
                            id: 'bulkdiassociate', label: 'Bulk De-Associate', tooltip: 'Bulk de-associate selected grants',
                            disabled: utils.isNull(this.state.IDs)
                        }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if ("bulkdiassociate" === buttonId) {
            this.setState({ formDialogOpen: true, removeMessage: "", DiscretionaryGrantTypeID: this.state.model.DiscretionaryGrantTypeID })
        }
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {
            toolbarRef.current.setButtonDisabled("bulkdiassociate", true);
            this.setState({
                formDialogOpen: false, IDs: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                formDialogOpen: false
            })
        }
    }

    //successCallback(response) {
    //    this.setState({ message: response.Message, messageStyle: response.MessageType });
    //}
    successCallback(response) {
        if (response.MessageType === "SUCCESS") {
            this.setState({
                showTable: false
            }, () => {
                this.setState({
                    showTable: true,
                    message: response.Message,
                    messageStyle: response.MessageType
                })
            });
        }
        else {
            this.setState({
                message: response.message, messageStyle: response.MessageType
            });
        }
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelections = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ IDs: selection, Message: "", LearnerCount: selection.length },
                () => {
                    if (utils.getCurrentRole() === roleSRU) {
                        if (this.state.DiscretionaryGrantTypeID !== "12" && this.state.DiscretionaryGrantTypeID !== "13" && this.state.DiscretionaryGrantTypeID !== "14" && this.state.DiscretionaryGrantTypeID !== "18") {
                            toolbarRef.current.setButtonDisabled("bulkdiassociate", true);
                        }
                        else { toolbarRef.current.setButtonDisabled("bulkdiassociate", false); }
                    }
                    else { toolbarRef.current.setButtonDisabled("bulkdiassociate", selection.length === 0); }
                }
            )
        }
        else {
            this.setState({ IDs: null, Message: "", LearnerCount: null },
                () => {
                    toolbarRef.current.setButtonDisabled("bulkdiassociate", selection.length === 0);
                }
            )
        }
    }

    handleFormValueChange = (values) => {

        let DiscretionaryGrantTypeID = null;
        let newsearchParameters = [...this.state.searchParameters];

        if (!utils.isNull(values.DiscretionaryGrantTypeID)) {
            DiscretionaryGrantTypeID = values.DiscretionaryGrantTypeID.Id;
            let temp_element = { ...newsearchParameters[0] };
            temp_element.Value = DiscretionaryGrantTypeID
            newsearchParameters[0] = temp_element;
        }

        this.setState({
            searchParameters: JSON.parse(JSON.stringify(newsearchParameters)),
            DiscretionaryGrantTypeID: DiscretionaryGrantTypeID
        });

        if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
            this.setState({ model: values });
        }
    }


    render() {

        return (
            <ViewContainer mode={this.props.mode} title={``}>
                <p className="breadcrumbs">
                    {"Bulk Grant De-Association"}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                {this.state.showTable === true && (
                <SearchView
                    headCells={headCells}
                    dataUrl="api/sims/BulkGrantDiAssociation/BulkGrantDiAssociationSearch"
                    model={this.state.model}
                    toolbarConfig={this.toolbarConfig}
                    mode={this.props.mode}
                    history={this.props.history}
                    multiSelect={true}
                    onLookupValueChange={this.props.onLookupValueChange}
                    buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={(selection) => { this.handleSelections(selection) }}
                    autoFetchData={false}
                    toolbarRef={toolbarRef}
                    searchLabel={"SEARCH"}
                    handleObject={true}
                >
                    <BulkAssociationSearchForm data={this.state.model} controllerName='BulkGrantDiAssociation'
                        valueChangeHandler={(values) => this.handleFormValueChange(values)} />

                    <FormDialog
                        open={this.state.formDialogOpen}
                        dialogTitle={"Bulk Grant De-Association Details"}
                        viewRef={this}
                        saveUrl={"api/sims/BulkGrantDiAssociation/BulkGrantDiAssociate"}
                        usePut={true}
                        formRef={addFormRef}
                        multiEntity={this.state.IDs}
                        entityInfo={this.state.model}
                        closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    >
                        <DiAssociationDetailForm ref={addFormRef} />

                    </FormDialog>
                </SearchView>
                )}
                <div> {'Total Learners: ' + this.state.LearnerCount} </div>  
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(BulkGrantDeAssociation));

